import React, { useEffect, useMemo, useState } from "react";
import API from "../../API";
import OrdersList from "./OrdersList";

export const PastOrders = () => {
  const [allOrders, setAllOrders] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [query, setQuery] = useState("");

  useEffect(() => {
    API.fetchHouseholds()
      .then((data) => setAllOrders(Array.isArray(data) ? data : []))
      .finally(() => setLoading(false));
  }, []);

  const visibleOrders = useMemo(() => {
    const term = query.trim().toLowerCase();
    return allOrders
      .filter((order) =>
        (order.household_name || "").toLowerCase().includes(term)
      )
      .sort((a, b) => (a.order_date < b.order_date ? 1 : -1));
  }, [allOrders, query]);

  return (
    <div className="orders_page">
      <div className="orders_bar">
        <h3 className="orders_title">Past Orders</h3>
        <input
          className="orders_search"
          type="text"
          placeholder="Search by family name…"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
        <span className="orders_count">
          {visibleOrders.length} order{visibleOrders.length === 1 ? "" : "s"}
        </span>
      </div>

      {loading ? (
        <div className="orders_empty">Loading orders…</div>
      ) : visibleOrders.length === 0 ? (
        <div className="orders_empty">
          {allOrders.length === 0 ? "No past orders." : "No orders found."}
        </div>
      ) : (
        <div className="orders_card_list">
          <OrdersList households={visibleOrders} />
        </div>
      )}
    </div>
  );
};
